export default function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div
      role="alert"
      className="p-4 border border-red-400 rounded text-red-700"
    >
      <p>❌ Đã xảy ra lỗi:</p>
      <pre className="whitespace-pre-wrap">
        {error?.stack || error?.message}
      </pre>
      <button
        onClick={resetErrorBoundary}
        className="mt-2 px-4 py-2 bg-red-500 text-white rounded"
      >
        Thử lại
      </button>
    </div>
  );
}
